export enum InvoiceStatusTypes {
  Draft = 'Draft',
  Sent = 'Sent',
  Overdue = 'Overdue',
  Paid = 'Paid',
  Void = 'Void',
  WriteOff = 'Write Off',
}
